import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { E911Location } from "../../../../../../common/services/api/resources/e911/e911-location";
import { UserAddressE911Info } from "../e911-table.component";

@Component({
  selector: "onsip-admin-e911-table-shelf-container",
  templateUrl: "./e911-table-shelf-container.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AdminE911TableShelfComponent {
  @Input() e911Location!: E911Location;
  @Input() userAddressE911Info!: Observable<Array<UserAddressE911Info>>;
  e911ShelfPanel = new BehaviorSubject<"view" | "edit">("view");

  togglePanel(panel: "view" | "edit"): void {
    this.e911ShelfPanel.next(panel);
  }
}
